const getters = {
  /**
   * Get current user
   * @param state
   * @returns {{name:String, email:String, title:String}}
   */
  getUser: state => {
    return state.user;
  },
  getInitAppSettings: state => {
    return state.appSettings;
  },
  getKeycloak: state => {
    return state.keycloak;
  },
  getPermissions: state => {
    return state.permissions;
  }
};

export default getters;
